import React, { useState } from 'react';
import SearchModal from './components/SearchModal';

// Componente para el ícono de propuestas (mano con manzana)
const PropuestasIcon = ({ size = 32, color = "#dc3545" }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none"
  >
    {/* Mano */}
    <path
      d="M8 12c0-2 1-3 2-3s2 1 2 3v2c0 1-1 2-2 2s-2-1-2-2v-2z"
      fill={color}
    />
    <path
      d="M12 9c0-1 1-2 2-2s2 1 2 2v5c0 1-1 2-2 2s-2-1-2-2V9z"
      fill={color}
    />
    <path
      d="M16 11c0-1 1-2 2-2s2 1 2 2v3c0 1-1 2-2 2s-2-1-2-2v-3z"
      fill={color}
    />
    {/* Manzana */}
    <circle
      cx="12"
      cy="8"
      r="3"
      fill={color}
    />
    {/* Corazón en la manzana */}
    <path
      d="M12 6.5c-0.5-0.5-1-0.5-1.5 0-0.5 0.5-0.5 1 0 1.5 0.5 0.5 1.5 0.5 1.5 0s0.5-1 0-1.5z"
      fill="white"
    />
  </svg>
);

// Componente para el ícono de reflexiones (lámpara)
const ReflexionesIcon = ({ size = 32, color = "#dc3545" }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none"
  >
    {/* Base de la lámpara */}
    <rect
      x="10"
      y="18"
      width="4"
      height="2"
      fill={color}
    />
    {/* Brazo de la lámpara */}
    <path
      d="M12 18v-8c-2 0-4-2-4-4s2-4 4-4 4 2 4 4-2 4-4 4z"
      fill={color}
    />
    {/* Pantalla de la lámpara */}
    <ellipse
      cx="12"
      cy="10"
      rx="3"
      ry="2"
      fill={color}
    />
    {/* Luz */}
    <ellipse
      cx="12"
      cy="12"
      rx="2"
      ry="1"
      fill="yellow"
      opacity="0.8"
    />
  </svg>
);

// Componente para el ícono de acompañamiento (burbuja de chat)
const AcompanamientoIcon = ({ size = 32, color = "#dc3545" }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none"
  >
    {/* Burbuja de chat */}
    <path
      d="M4 4h16c1.1 0 2 .9 2 2v8c0 1.1-.9 2-2 2h-4l-4 4-4-4H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
      fill={color}
    />
    {/* Puntos de chat */}
    <circle cx="8" cy="10" r="1" fill="white" />
    <circle cx="12" cy="10" r="1" fill="white" />
    <circle cx="16" cy="10" r="1" fill="white" />
    <circle cx="10" cy="14" r="1" fill="white" />
  </svg>
);

// Componente para cada elemento de la lista
const MenuItem = ({ icon: Icon, title, onClick }) => (
  <div 
    onClick={onClick}
    className="flex items-center justify-between py-4 px-4 border-b border-gray-200 cursor-pointer hover:bg-gray-50 transition-colors"
  >
    <div className="flex items-center space-x-4">
      <Icon size={32} />
      <span className="text-gray-800 font-medium">{title}</span>
    </div>
    <span className="text-gray-400 text-lg">›</span>
  </div>
);

// Vista principal "Ven y Verás"
const VenYVerasView = ({ onBack }) => {
  // Estado para el modal de búsqueda
  const [showSearchModal, setShowSearchModal] = useState(false);

  const handlePropuestas = () => {
    console.log('Propuestas clicked');
    // Aquí iría la navegación a la vista de propuestas
  };

  const handleReflexiones = () => {
    console.log('Reflexiones clicked');
    // Aquí iría la navegación a la vista de reflexiones
  };

  const handleAcompanamiento = () => {
    console.log('Acompañamiento clicked');
    // Aquí iría la navegación a la vista de acompañamiento
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header rojo */}
      <header className="bg-red-600 text-white px-4 py-6">
        <div className="flex items-center justify-between mb-4">
          <button 
            onClick={onBack}
            className="text-2xl hover:opacity-80 transition-opacity"
            aria-label="Volver atrás"
          >
            ☰
          </button>
          <button 
            onClick={() => {
              console.log('🔍 Abriendo búsqueda desde Ven y Verás');
              setShowSearchModal(true);
            }}
            className="text-xl hover:opacity-80 transition-opacity"
            aria-label="Buscar"
          >
            🔍
          </button>
        </div>
        
        <div className="text-center">
          <h1 className="text-3xl font-bold mb-2">Ven y Verás</h1>
          <p className="text-sm opacity-90 leading-relaxed">
            Da un paso adelante con nuestras propuestas y reflexiones.
          </p>
          <p className="text-sm opacity-90">
            Únete a nuestra familia agustiniana
          </p>
        </div>
      </header>

      {/* Contenido principal */}
      <main className="bg-white">
        <MenuItem 
          icon={PropuestasIcon}
          title="Propuestas"
          onClick={handlePropuestas}
        />
        <MenuItem 
          icon={ReflexionesIcon}
          title="Reflexiones"
          onClick={handleReflexiones}
        />
        <MenuItem 
          icon={AcompanamientoIcon}
          title="Acompañamiento - Consúltanos"
          onClick={handleAcompanamiento}
        />
      </main>

      {/* Modal de búsqueda */}
      <SearchModal
        isOpen={showSearchModal}
        onClose={() => setShowSearchModal(false)}
        currentSection={null} // Buscar en todas las secciones
        onArticleClick={(article, section) => {
          console.log('📎 Artículo seleccionado desde búsqueda en Ven y Verás:', article.title);
          // Disparar evento global para que App.js maneje la navegación
          const event = new CustomEvent('navigateToArticle', {
            detail: { article, section }
          });
          window.dispatchEvent(event);
        }}
      />
    </div>
  );
};

export default VenYVerasView; 